import script from "./BP.vue?vue&type=script&setup=true&lang=js"
export * from "./BP.vue?vue&type=script&setup=true&lang=js"

import "./BP.vue?vue&type=style&index=0&id=a31b0246&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a31b0246"]])

export default __exports__